export default __webpack_public_path__ + "4f5eddba5c38262cd5879b82b77da6cf.svg";